export const TeamConstants = {
    TRACK_TEAM_PERMISSION_CLICK: 'helpdesk-agents-team-permission-clicked',
    TRACK_ATTENDANT_PERMISSION_CLICK: 'helpdesk-agents-attendant-permission-clicked',
    TRACK_ATTENDANT_PERMISSION: {
        CAN_SEND_ACTIVE_MESSAGE: 'helpdesk-agents-permission-activemessage',
        CAN_EDIT_CONTACT: 'helpdesk-agents-permission-editcontact',
        CAN_CALLS_VOICE_INBOUND: 'helpdesk-agents-permission-receivingcall',
    },
    TRACK_ORGANIZATION_LINK_CLICK: 'helpdesk-agents-organization-link-clicked',
    ATTENDANTS_TO_PERMISSION_STORED: 'AtendantsToPermission',
    ATTENDANT_PERMISSION_ROUTE: 'auth.application.detail.attendance.team.permission',
};
